import {AppStore} from "../../desktop";
import {Document} from "../../models/Document";
import {DocumentsActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";
import {ContractsActionTypes} from "../contracts";

export const actionDocumentFetchAll = () => {
	AppStore.dispatch({type: DocumentsActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionDocumentForIndexingFetchAll = () => {
	AppStore.dispatch({type: DocumentsActionTypes.FETCH_INDEXING_ALL_REQUEST, payload: null})
}

export const actionDocumentFetchAllCompleted = (documents: Document[]) => {
	AppStore.dispatch({type: DocumentsActionTypes.FETCH_ALL_COMPLETED, payload: documents})
}

export const actionDocumentForIndexingFetchAllCompleted = (documents: Document[]) => {
	AppStore.dispatch({type: DocumentsActionTypes.FETCH_INDEXING_ALL_COMPLETED, payload: documents})
}

export const actionDocumentFetch = (document: Document) => {
	AppStore.dispatch({type: DocumentsActionTypes.FETCH_ONE_REQUEST, payload: document})
}

export const actionDocumentFetchCompleted = (document: Document) => {
	AppStore.dispatch({type: DocumentsActionTypes.FETCH_ONE_COMPLETED, payload: document})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: document})
}

export const actionDocumentSave = (document: Document) => {
	AppStore.dispatch({type: DocumentsActionTypes.SAVE_REQUEST, payload: document})
}

export const actionDocumentSaveCompleted = (document: Document) => {
	AppStore.dispatch({type: DocumentsActionTypes.SAVE_COMPLETED, payload: document})
}

export const actionDocumentDelete = (document: Document) => {
	AppStore.dispatch({type: DocumentsActionTypes.DELETE_REQUEST, payload: document})
}

export const actionDocumentDeleteCompleted = (document: Document) => {
	AppStore.dispatch({type: DocumentsActionTypes.DELETE_COMPLETED, payload: document})
}

export const actionDeleteDocuments = (documents: Document[], unindexed?: boolean) => {
	AppStore.dispatch({type: DocumentsActionTypes.DELETE_MULTIPLE_REQUEST, payload: {documents, unindexed}})
}

export const actionDeleteDocumentsCompleted = (documents: Document[]) => {
	AppStore.dispatch({type: DocumentsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: documents})
}

export const actionDocumentPerformAction = (document: Document, action: string) => {
	AppStore.dispatch({type: DocumentsActionTypes.PERFORM_ACTION_REQUEST, payload: {document, action}})
}

export const actionDocumentIndexingNumberRequest = () => {
	AppStore.dispatch({type: DocumentsActionTypes.INDEXING_NUMBER_REQUEST, payload: null})
}

export const actionDocumentIndexingNumberCompleted = (indexingNumber: string) => {
	AppStore.dispatch({type: DocumentsActionTypes.INDEXING_NUMBER_COMPLETED, payload: indexingNumber})
}
